const get = (key: string): string => {
  const value = import.meta.env[key]
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Missing required env var: ${key}`)
  }
  return value
}

export const env = {
  API_URL: get('VITE_API_URL'),
}
